import { render, staticRenderFns } from "./Visitors.vue?vue&type=template&id=2060e95a&scoped=true"
import script from "./Visitors.vue?vue&type=script&lang=js"
export * from "./Visitors.vue?vue&type=script&lang=js"
import style0 from "./Visitors.vue?vue&type=style&index=0&id=2060e95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060e95a",
  null
  
)

export default component.exports